export const quotes = [
  {
    text: "七転び八起き",
    author: "日本のことわざ"
  },
  {
    text: "一期一会",
    author: "茶道の心得"
  },
  {
    text: "努力は必ず報われる。もし報われない努力があるのならば、それはまだ努力と呼べない。",
    author: "王貞治"
  },
  {
    text: "何事も基礎がなっていないのに、花ばかり咲こうとしても、しおれるにきまっている。",
    author: "松下幸之助"
  },
  {
    text: "現在は過去と未来の間にある。",
    author: "ブッダ"
  },
  {
    text: "成功とは、失敗から失敗へと歩み続けても情熱を失わないことだ。",
    author: "ウィンストン・チャーチル"
  },
  {
    text: "今日という日は、残りの人生の最初の日である。",
    author: "アビー・ホフマン"
  },
  {
    text: "雨垂れ石を穿つ",
    author: "日本のことわざ"
  },
  {
    text: "継続は力なり",
    author: "日本のことわざ"
  },
  {
    text: "明日は明日の風が吹く",
    author: "日本のことわざ"
  },
  {
    text: "心配は身体に毒である。",
    author: "デール・カーネギー"
  },
  {
    text: "人生は自転車に乗るようなものだ。倒れないためには走り続けなければならない。",
    author: "アルベルト・アインシュタイン"
  },
  {
    text: "花は一日にして咲かず",
    author: "日本のことわざ"
  },
  {
    text: "時は金なり",
    author: "ベンジャミン・フランクリン"
  },
  {
    text: "過去を変えることはできないが、未来を変えることはできる。",
    author: "作者不明"
  },
  {
    text: "笑顔は世界共通の言語である。",
    author: "作者不明"
  },
  {
    text: "夢を見ることができれば、それを実現することもできる。",
    author: "ウォルト・ディズニー"
  },
  {
    text: "人生に失敗がないと、人生を失敗する。",
    author: "斎藤茂太"
  },
  {
    text: "できると思うか、できないと思うか、どちらも正しい。",
    author: "ヘンリー・フォード"
  },
  {
    text: "一生懸命努力すれば、運も味方してくれる。",
    author: "トーマス・ジェファーソン"
  }
]